import { Component, OnInit, ViewChild, ViewChildren, Output, EventEmitter } from '@angular/core';
import { DgHojaEvalComponent } from '../datos-general/dg-hoja-eval/dg-hoja-eval.component';
import { FurService } from 'src/app/services/fur.service';
import { AntecedentesFurComponent } from './antecedentes-fur/antecedentes-fur.component';
import { ResAnalisisService } from 'src/app/services/res-analisis.service';
import { ResAnalisis } from 'src/app/models/ResAnalisis';
import { HojaEvaluacion } from 'src/app/models/HojaEvaluacion';
import { HojaEvaluacionService } from 'src/app/services/hoja-evaluacion.service';
import { EvidenciasComponent } from '../denuncia/evidencias/evidencias.component';
import { ErrorValidator } from 'src/app/models/personalizados/ErrorValidator';
// import { MfuncErrorVal} from 'src/app/general/variables';
import { ContenedorWebComponent } from '../formulario-web/contenedor-web/contenedor-web.component';
// import { MfuncErrorVal, GlobalVars, openModalMensaje, NumIdEstadoAtendido, GetDateTime} from 'src/app/general/variables';
// import { ActivatedRoute, Router } from '@angular/router';
import { Fur } from 'src/app/models/Fur';
import { MfuncErrorVal, GlobalVars, openModalMensaje, NumIdEstadoAtendido, GetDateTimeString, GetDateTime, NumIdEstadoHeSuperv, NumIdEstadoHeEvaluac, CodTipoFichaHe, NumIdEstadoHeEvaluacionSuperv, NumIdEstadoFudPendiente, NumIdEstadoHeEvaluacionObservado, iconEliminar, NumResultadoAnalisDenuncia, DscTituloPaginator, iconDescargar, CargarDatosPlantilla, NumIdTipCatCampPlantHE, RecupObjDatosPlant, NumIdParamRutaArchGen, NumIdCatTipoPD, NumIdCatNombrPlantFW, NumIdCatDocGenFW, NumIdParamRutaArchPlan, CodSubTipoFichaOFI, DscNombreFileOficioHEV, isNotEmptyList, saveContent, NumIdTipDenPersNat, NumIdCatTipoDest1, CodTipoFichaFUR, CodSubTipoFichaDOC, CodSubTipoFichaCAR, NumIdTipCatDerivHe, NumIdResAnPedInf, NumIdTipCatMotAccRea, NumIdResAnInfComp, iconBuscar, NumIdRADenAuditInt, isEmpty, isNotEmpty, NumIdRAInfoOtraEnt, NumIdTipCatMotEntidad, NumIdRADesestInfo, NumIdTipCatMotDesest} from 'src/app/general/variables';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { PersonalCgrService } from 'src/app/services/personal-cgr.service';
import { PersonalCgr } from 'src/app/models/PersonalCgr';
import { Fud } from 'src/app/models/Fud';
import { FudService } from 'src/app/services/fud.service';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { ObservacionDetalle } from 'src/app/models/observacionDetalle';
import { EvaluacionPreliminar } from 'src/app/models/BPM/evaluacionPreliminar';
import { PDDatos } from 'src/app/models/PDDatos';
import { CatalogoService } from 'src/app/services/Catalogo.service';
import { General } from 'src/app/models/General';
import { ParametroService } from 'src/app/services/parametro.service';
import { PlantillaDocumento } from 'src/app/models/PlantillaDocumento';
import { Observable } from 'rxjs/internal/Observable';
import { NgxSpinnerService } from 'ngx-spinner';
import { ExternosService } from 'src/app/services/externos/externos.service';
import { DocumentosEmitidosComponent } from '../General/documentos-emitidos/documentos-emitidos.component';
import { DocumentoDet } from 'src/app/models/DocumentoDet';
import { ModalGenerarDocSgdComponent } from './modal-generar-doc-sgd/modal-generar-doc-sgd.component';
import { Catalogo } from 'src/app/models/Catalogo';
import { ModalBusqFurComplComponent } from './modal-busq-fur-compl/modal-busq-fur-compl.component';
import { UniOrganicaService } from 'src/app/services/uni-organica.service';
import { UniOrganica } from 'src/app/models/UniOrganica';
import { Entidad } from 'src/app/models/Entidad';
import { BusqEntidadComponent } from '../general/busq-entidad/busq-entidad.component';

@Component({
  selector: 'app-evalinf-regfur',
  templateUrl: './evalinf-regfur.component.html',
  styleUrls: ['./evalinf-regfur.component.css']
})
export class EvalinfRegfurComponent implements OnInit {

  // PROPIEDADES EN VISTA
  numIdResAnalisis: number = null;
  dscResConclus = '';
  dscResRecomen = '';
  flgMostrarTabFur = false;
  strCodUNO = '';

  strCodSupervDer = '';
  strDscComentarios = '';
  flgDeshabilitado = true;
  iconDescargar = iconDescargar;
  pdDatos: PDDatos[] = [];
  // PROPIEDADES EN VISTA

  idFur: number;
  listSupervisor: PersonalCgr[] = [];

  @ViewChild(DgHojaEvalComponent) dgHojaEvalC: DgHojaEvalComponent;
  @ViewChild(AntecedentesFurComponent) antecedentesFurC: AntecedentesFurComponent;
  @ViewChild(EvidenciasComponent) evidenciasC: EvidenciasComponent;
  @ViewChild(DocumentosEmitidosComponent) documentosEmitidosC: DocumentosEmitidosComponent;

  @ViewChild(ContenedorWebComponent) formularioCmp: ContenedorWebComponent;
  @ViewChild(BusqEntidadComponent) busqEntidadC: BusqEntidadComponent;

  @Output() opRetornaEvaluar = new EventEmitter();
  // @ViewChildren(FormularioWebComponent) formularioCmp : FormularioWebComponent;

  listResAnalisis: ResAnalisis[] = [];
  hojaEvaluacion: HojaEvaluacion = new HojaEvaluacion();
  errorValidator: ErrorValidator[] = [];
  mFuncErrorVal: MfuncErrorVal = new MfuncErrorVal();
  fur: Fur = new Fur();
  idFUrBaseV: number ;
  numIdFurCompl: number;
  iconBuscar = iconBuscar;
  /*
  CUS06
  */
  flgSegundaEval = false;
  furEvaluacion: Fur = new Fur();
  flgExisteAntecedente = '';
  flgTipoAntecedente = '';
  flgInformacionComplementaria = '';
  flgTipoInformacion = '';
  flgTipoDenuncia = '';
  fud: Fud = new Fud();
  flgEsFudEval = false;
  strCodResponsable = '';
  strDscResponsable = '';
  strCodEntidad: string = null;

  /*
  */
  /**CUS 07 */
  flgLecturaFud = false;
  observacion = '';
  hojaEvaluacionSegundaEval: HojaEvaluacion = new HojaEvaluacion();
  matTableColumnsDef = ['observacion', 'estado', 'acciones'];
  dataSource: MatTableDataSource<ObservacionDetalle>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  listaObservaciones: ObservacionDetalle[] = [];
  estadoFurEvaluacion: number;
  strDscRutaArchivoGen: string = null;
  strDscNombrPlantilla: string = null;
  strDscNomArchivoGen: string = null;
  strDscRutaArchivoPlant: string = null;
  listaMotivo: Catalogo[] = [];
  numIdMotivo: number = null;
    // Icons
  iconoEliminar = iconEliminar;
  isNotEmptyList = isNotEmptyList;
  listMotivoAcc: Catalogo[] = [];
  listMotivoEnt: Catalogo[] = [];
  listMotivoDesest: Catalogo[] = [];
  numIdMotivoAcc: number;
  listUNO: UniOrganica[] = [];
  strCodRespDef = '70003';
  /* */
  constructor(protected furService: FurService,
              protected resAnalisisService: ResAnalisisService,
              protected hojaEvaluacionService: HojaEvaluacionService,
              public router: Router,
              protected uniOrganicaService: UniOrganicaService,

              protected serviceFur: FurService,
              public dialog: MatDialog,
              protected personalCgrService: PersonalCgrService,
              protected fudService: FudService,

              protected catalogoService: CatalogoService,
              protected parametroService: ParametroService,
              private spinner: NgxSpinnerService,
              protected externosService: ExternosService

    ) {


    }

  ngOnInit() {

    this.catalogoService.listarCatalogo(NumIdTipCatCampPlantHE).subscribe(
      data => {

        this.pdDatos = CargarDatosPlantilla(data);

      });

    this.catalogoService.listarCatalogo(NumIdTipCatDerivHe).subscribe(
      data => {

        this.listaMotivo = data;

      });

    this.catalogoService.listarCatalogo(NumIdTipCatMotAccRea).subscribe(
      data => {

        this.listMotivoAcc = data;

      });

    this.catalogoService.listarCatalogo(NumIdTipCatMotEntidad).subscribe(
      data => {

        this.listMotivoEnt = data;

      });

    this.catalogoService.listarCatalogo(NumIdTipCatMotDesest).subscribe(
      data => {

        this.listMotivoDesest = data;

      });



    this.parametroService.obtenerParametro(NumIdParamRutaArchPlan).subscribe(
      data => {

        this.strDscRutaArchivoPlant = data.cparamValor;

      });

    this.parametroService.obtenerParametro(NumIdParamRutaArchGen).subscribe(
      data => {

        this.strDscRutaArchivoGen = data.cparamValor;

      });

    this.catalogoService.listarCatalogo(NumIdCatTipoPD).subscribe(
      data => {

        this.strDscNombrPlantilla = data.find(x => x.ncatalogoId == NumIdCatNombrPlantFW).ccatalogoDsc;
        this.strDscNomArchivoGen = data.find(x => x.ncatalogoId == NumIdCatDocGenFW).ccatalogoDsc;

      });

    this.evidenciasC.setStrDscColEtiq1('Descripción');


    this.uniOrganicaService.ListarUnidadOrganicaActiva().subscribe(data => {

      this.listUNO = data;

    });

  }

  _generaDocOut(general: General) {

    if (general.flgCampo1 || general.flgCampo2) {

      const dialogRef = this.dialog.open(ModalGenerarDocSgdComponent, { width: '95%', height: '95%',
        data: {departamento: '1', provincia: '1', distrito: '1', direccion: 'av. direccion'}});

      dialogRef.afterClosed().subscribe(result => {

      });

      this._generarPlantillaHE().subscribe(data => {

      });

    }

  }

  _getDocEmitidos(flgGuardar: boolean) {

    let vListado = null;

    if (this.documentosEmitidosC != null) {

      vListado = this.documentosEmitidosC.getDocumentosEmitC(flgGuardar);

    }

    return vListado;

  }

  _buscarFurCompl() {

    let vFur: Fur = null;

    const dialogRef = this.dialog.open(ModalBusqFurComplComponent, { width: '90%', height: '80%'});

    dialogRef.afterClosed().subscribe(result => {

      vFur = result;

      if (vFur) {

        this.numIdFurCompl = vFur.nfurId;

      }

    });

  }

  _generarPlantillaHE() {


    // var vListGeneralFinal:General[] = [];
    const vPlantillaDocumento: PlantillaDocumento = new PlantillaDocumento();
    const vDocumento: DocumentoDet = new DocumentoDet();
    const vFurAntec: Fur = this.antecedentesFurC.getAntecedenteFurC();
    let vIdTipDenunciante: number = null;
    let vIdMedNotif: number = null;
    // var vListDocumentoDet:DocumentoDet[] = [];
    // var vFur:Fur = null;


    if (vFurAntec.cfurFlgreqidentif == 'SI') {

      vIdTipDenunciante = vFurAntec.denunciante.ndenuncianteIdtipden;
      vIdMedNotif = vFurAntec.denunciante.ndenuncianteIdmedionotif;

    }

    vPlantillaDocumento.datos = [];
    // vPlantillaDocumento.tabla = [];

    const plantillaObservable = new Observable(observer => {

      // vFur = data;

      // SPAGHETTI DE DATOS

      // this.pdDatos = RecupObjDatosPlant(this.hojaEvaluacion,this.pdDatos);

      vPlantillaDocumento.rutaArchivoPlantilla = this.strDscRutaArchivoPlant;
      vPlantillaDocumento.nombreArchivoPlantilla = this.strDscNombrPlantilla;
      vPlantillaDocumento.rutaArchivoGenerado = this.strDscRutaArchivoGen;
      vPlantillaDocumento.nombreArchivoGenerado = this.strDscNomArchivoGen;

      this.spinner.show();

      console.log('===============vPlantillaDocumento');
      console.log(JSON.stringify(vPlantillaDocumento));

      this.externosService.generarDocumento(vPlantillaDocumento).subscribe(
        data => {

          this.spinner.hide();

          // console.log("===============111111111");
          // console.log(data);

          vDocumento.cdocumentoCodtipo = CodTipoFichaHe;
          vDocumento.cdocumentoCodsubtipo = CodSubTipoFichaOFI;
          vDocumento.cdocumentoDscnombre = DscNombreFileOficioHEV;
          vDocumento.strDdocumentoFchreg = GetDateTime(0, 0);
          vDocumento.fileBase64 = data.base64;
          vDocumento.ndocumentoIdtipodest = (vIdTipDenunciante == NumIdTipDenPersNat ? NumIdCatTipoDest1 : null);
          vDocumento.ndocumentoIdmednotif = vIdMedNotif;

          // console.log("===============2222222");


          this.documentosEmitidosC.setPushDocumentosEmitC(vDocumento);

        },
        err => {

          this.spinner.hide();

          console.log(err);

        });



    });

    return plantillaObservable;

  }

  mostrarRegistro(idFur: number) {

    this.idFur = idFur; // this.route.snapshot.params.idFur;

    setTimeout(() => {

      // console.log("============recuperar13");

      this.dgHojaEvalC.DatosDefault();

      this._obtenerDatosFur(this.idFur); // TAMBIEN RECUPERA DATOS DE HOJA EVAL


      this.antecedentesFurC.RecuperarAntecedentes(this.idFur); // temporal




    }, 5);



  }

  _setDatosHe(boolFlgSuperv: boolean) {

    // console.log("=========this.numIdResAnalisis");
    // console.log(this.numIdResAnalisis);

    const furAntec = this.antecedentesFurC.listFormWeb[0];

    // var vListDocumentos:DocumentoDet[] = this._getDocEmitidos();


    this.hojaEvaluacion.strDhojaevalFregini = this.dgHojaEvalC.fchHrInicioReg;
    this.hojaEvaluacion.nhojaevalIdfur = furAntec.nfurId;
    this.hojaEvaluacion.nhojaevalIdresanalisis = this.numIdResAnalisis;
    this.hojaEvaluacion.chojaevalDscconclusion1 = this.dscResConclus;
    this.hojaEvaluacion.chojaevalDscconclusion2 = this.dscResRecomen;
    // this.hojaEvaluacion.listaDocumentoDetalle = this.evidenciasC.getEvidenciasC();
    this.hojaEvaluacion.chojaevalCodsnc = GlobalVars.CodSNC;
    this.hojaEvaluacion.chojaevalComentarios = this.strDscComentarios;
    this.hojaEvaluacion.chojaevalCodsupervder = this.strCodSupervDer;
    this.hojaEvaluacion.chojaevalCodusureg = GlobalVars.CodPersonal;
    this.hojaEvaluacion.nhojaevalIdmotderiv = this.numIdMotivo;
    this.hojaEvaluacion.nhojaevalIdmotaccion = this.numIdMotivoAcc;
    this.hojaEvaluacion.chojaevalCoduno = this.strCodUNO;
    this.hojaEvaluacion.chojaevalCodrespaccion = this.strCodResponsable;
    this.hojaEvaluacion.nhojaevalIdcalfur = this.numIdFurCompl;
    this.hojaEvaluacion.chojaevalCodent = this.strCodEntidad;
    // this._setCodEntidad(this.strCodEntidad);




    // //SOLO PARA QUE SEAN ALMACENADOS
    // this.hojaEvaluacion.listaDocumento = vListDocumentos;

    // vListDocumentos.forEach(element => {

    //   element.listaCargo.forEach(element => {

    //     this.hojaEvaluacion.listaCargo.push(element);

    //   });

    // });

    if (boolFlgSuperv) {

      this.hojaEvaluacion.strDhojaevalFregistro = GetDateTime(0, 0);
      this.hojaEvaluacion.nhojaevalIdestado = NumIdEstadoHeSuperv;
      furAntec.nfurIdestado = NumIdEstadoAtendido;

    } else {

      this.hojaEvaluacion.nhojaevalIdestado = NumIdEstadoHeEvaluac;
    }
    /**Cus06 */
    this.hojaEvaluacion.chojaevalFlgexisantec = this.flgExisteAntecedente;
    this.hojaEvaluacion.chojaevalFlgtipoantec = this.flgTipoAntecedente;
    this.hojaEvaluacion.chojaevalTipinform = this.flgTipoInformacion;
    this.hojaEvaluacion.chojaevalTipodenun = this.flgTipoDenuncia;
    this.hojaEvaluacion.chojaevalFlginfcompl = this.flgInformacionComplementaria;

    return furAntec;

  }

  _prepararListaCargo(listDoc: DocumentoDet[]) {

    let vNewDoc: DocumentoDet = null;
    const vListCargo: DocumentoDet[] = [];

    listDoc.forEach(element => {

      vNewDoc = new DocumentoDet();

      vNewDoc = element;

      vNewDoc.listaCargo.forEach(element1 => {

        element1.ndocumentoIdbase = vNewDoc.ndocumentoId;

        vListCargo.push(element1);

      });

    });

    return vListCargo;


  }

  _Guardar() {


    // var vListCargo:DocumentoDet[] = [];



    let vIdHoja;

    // var furAntec = this._setDatosHe(false);

    this._setDatosHe(false);

    // this.hojaEvaluacion.strDhojaevalFregini= this.dgHojaEvalC.fchHrInicioReg;
    // //this.hojaEvaluacion.strDhojaevalFregistro = GetDateTime();
    // this.hojaEvaluacion.nhojaevalIdfur = this.antecedentesFurC.listFormWeb[0].nfurId;
    // this.hojaEvaluacion.nhojaevalIdresanalisis = this.numIdResAnalisis;
    // this.hojaEvaluacion.chojaevalDscconclusion1 = this.dscResConclus;
    // this.hojaEvaluacion.chojaevalDscconclusion2 = this.dscResRecomen;

    // this.hojaEvaluacion.listaDocumentoAdjuntoDet = this.evidenciasC.listEvidencias;

    // //fur.nfurIdestado = NumIdEstadoAtendido;



    console.log('==============this.hojaEvaluacion');
    console.log(JSON.stringify(this.hojaEvaluacion));

    if (this.hojaEvaluacion.nhojaevalId > 0) {

      this.spinner.show();

      this.hojaEvaluacionService.ActualizarHojaEvaluacion(this.hojaEvaluacion).subscribe(data => {

        this.spinner.hide();

        vIdHoja = data.nhojaevalId;

        if (vIdHoja > 0) {

          this._procesarArchivos(vIdHoja, false, 0);

        } else {

          openModalMensaje('Asignar Información', 'Ocurrió un problema en la actualización del registro', this.dialog).afterClosed().subscribe(result => {

            this._Retornar();

          });

          // flgGuardado = false;

          return;

        }

      });

    } else {

      this.spinner.show();

      this.hojaEvaluacionService.RegistrarHojaEvaluacion(this.hojaEvaluacion).subscribe(data => {

        this.spinner.hide();

        vIdHoja = data.nhojaevalId;

        // console.log("============vIdHoja");
        // console.log(vIdHoja);


        if (vIdHoja > 0) {

          this._procesarArchivos(vIdHoja, false, 0);

        } else {

          openModalMensaje('Asignar Información', 'Ocurrió un problema en la actualización del registro', this.dialog).afterClosed().subscribe(result => {

            this._Retornar();

          });

          return;

        }

      });

    }



  }

  _procesarArchivos(idHe: number, flgRegFur: boolean, numCasoFur: number) {

    // var vListCargo:DocumentoDet[] = [];
    const vListDocumentos: DocumentoDet[] = this._getDocEmitidos(true);

    this.spinner.show();




  }

  _flgRAPedidoInfo() {

    return (this.numIdResAnalisis == NumIdResAnPedInf);

  }

  _flgRAInfoCompl() {

    return (this.numIdResAnalisis == NumIdResAnInfComp);

  }

  _flgRADenAuditInt() {

    return (this.numIdResAnalisis == NumIdRADenAuditInt);

  }

  _flgRAInfoOtraEnt() {

    return (this.numIdResAnalisis == NumIdRAInfoOtraEnt);

  }

  _flgRADesestInfo() {

    return (this.numIdResAnalisis == NumIdRADesestInfo);

  }

  _setCodEntidadOut(entidadSelec: Entidad) {

    // this.hojaEvaluacion.chojaevalCodent = entidadSelec.centCodigo;

    // this.strCodEntidad = entidadSelec.centCodigo;
    this._setCodEntidad(entidadSelec.centCodigo);

    this._setStrCodResponsable(this.strCodRespDef);

    // this.ValidarDatos();
    // this.strCodEntidad = entidadSelec.centCodigo;

  }

  _flgResAnalisisTipo(numCaso: number) {

    let vFlgReturn = false;

    switch (numCaso) {
      case 1:

        vFlgReturn = this._flgRAPedidoInfo();

        break;

      case 2:

        vFlgReturn = this._flgRAInfoCompl();

        break;

      case 3:

        vFlgReturn = (this._flgRAInfoCompl() || this._flgRAPedidoInfo() || this._flgRADenAuditInt());

        break;

      case 4:

        vFlgReturn = (this._flgRAInfoCompl() || this._flgRAPedidoInfo() || this._flgRADenAuditInt() || this._flgRAInfoOtraEnt() || this._flgRADesestInfo());

        break;

      default:
        break;
    }

    return vFlgReturn;

  }

  _postTransacHe(idHoja: number, flgRegFur: boolean, numCasoFur: number) {

    openModalMensaje('Hoja Evaluación', `Se registró correctamente la hoja de evaluación N° ${idHoja}, por favor verifique`,
    this.dialog).afterClosed().subscribe(result => {

      if (flgRegFur) {

        switch (numCasoFur) {
          case 1:

            this._GuardarFur(this.idFur, null, null, null);

            break;

          case 2:

            this._GuardarFur(this.furEvaluacion.nfurId, this.strCodSupervDer, GlobalVars.CodPersonal, this.estadoFurEvaluacion);

            break;

          default:
            break;
        }

        setTimeout(() => {

          this._Retornar();

        }, 5);

      } else {

        this._Retornar();

      }

    });

  }

  _supervisor() {

    let furAntec;
    let vIdHoja;

    // console.log("==============valiacion");

    // console.log(this.dscResConclus);
    // console.log(this.dscResRecomen);
    // console.log(this.strCodSupervDer);
    // console.log(this.strDscComentarios);

    this.errorValidator = this.mFuncErrorVal.AgregarErrorValidator((this.numIdResAnalisis != null ? false : true), 'Ingrese el resultado del análisis', this.errorValidator, true);
    this.errorValidator = this.mFuncErrorVal.AgregarErrorValidator((this.dscResConclus.length > 0 ? false : true), 'Ingrese la conclusión', this.errorValidator, false);
    this.errorValidator = this.mFuncErrorVal.AgregarErrorValidator((this.dscResRecomen.length > 0 ? false : true), 'Ingrese la recomendación', this.errorValidator, false);
    this.errorValidator = this.mFuncErrorVal.AgregarErrorValidator((this.strCodSupervDer.length > 0 ? false : true), 'Ingrese al supervisor', this.errorValidator, false);
    this.errorValidator = this.mFuncErrorVal.AgregarErrorValidator((this.strDscComentarios.length > 0 ? false : true), 'Ingrese los comentarios', this.errorValidator, false);

    this.errorValidator = this.mFuncErrorVal.AgregarErrorValidator((this.numIdMotivo != null ? false : true), 'Ingrese el motivo de la derivación', this.errorValidator, false);

    if (this._flgRAPedidoInfo()) {

      this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex((this.numIdMotivoAcc != null ? false : true), 'Ingrese el motivo de la acción a realizar', this.errorValidator, 6);

    }

    if (this._flgRAInfoCompl()) {

      this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex((this.numIdFurCompl != null ? false : true), 'Ingrese el fur complementario', this.errorValidator, 7);

    }

    if (this._flgRADenAuditInt()) {

      this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex((isNotEmpty(this.strCodUNO) ? false : true), 'Ingrese el fur complementario', this.errorValidator, 8);

    }

    if (this._flgRAInfoOtraEnt()) {

      this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex((isNotEmpty(this.strCodEntidad) ? false : true), 'Ingrese la entidad', this.errorValidator, 9);

      this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex((this.numIdMotivoAcc != null ? false : true), 'Ingrese el motivo de la acción a realizar', this.errorValidator, 10);

    }

    // this.hojaEvaluacion.chojaevalCodent = this.strCodEntidad;



    // console.log("==============valiacion11111");

    //  console.log("==========antes de guardar");
    //  console.log(this.mFuncErrorVal);
    // console.log(this.errorValidator);

    // if(this.errorValidator.filter(x => x.flgInvalid).length > 0)
    if (this.mFuncErrorVal.RevisarErrorValidator(this.errorValidator)) {return; }

    // console.log("a grabar");
    furAntec = this._setDatosHe(true);
   /*  this.hojaEvaluacion.strDhojaevalFregini = this.dgHojaEvalC.fchHrInicioReg;
    this.hojaEvaluacion.strDhojaevalFregistro = GetDateTime();
    this.hojaEvaluacion.nhojaevalIdfur = fur.nfurId;
    this.hojaEvaluacion.nhojaevalIdresanalisis = this.numIdResAnalisis;
    this.hojaEvaluacion.chojaevalDscconclusion1 = this.dscResConclus;
    this.hojaEvaluacion.chojaevalDscconclusion2 = this.dscResRecomen;

    this.hojaEvaluacion.listaDocumentoDetalle = this.evidenciasC.listEvidencias;

    fur.nfurIdestado = NumIdEstadoAtendido; */
    // this.hojaEvaluacion.nhojaevalIdresanalisis = this.formHojaEvaluacion.controls.select_resanali.;


    console.log('==============this.hojaEvaluacion');
    console.log(JSON.stringify(this.hojaEvaluacion));
    // if(this.codResAnalisis == "1"){
    //  // this.formularioCmp.Guardar(this.idFur);
    // }
    console.log('Segunda evaluación: ' + this.flgSegundaEval);

    if (this.flgSegundaEval) {

        if (this.hojaEvaluacion.nhojaevalId != 0) {

          this.furEvaluacion.hojaEvaluacion = this.hojaEvaluacion;

        //   console.log("Rgistro de hoja de evluación II");
        //  console.log(this.hojaEvaluacion);
        //  console.log(this.furEvaluacion);

          if (this.estadoFurEvaluacion == NumIdEstadoHeEvaluacionObservado) {

            this._devolverObservacionASupervisor();

          } else {

            if (this.estadoFurEvaluacion != NumIdEstadoHeEvaluacionSuperv) {

              this.estadoFurEvaluacion = NumIdEstadoHeEvaluacionSuperv;

              this._enviarFurASupervisor();

            }

          }


        }

    } else {

      this.spinner.show();

      this.hojaEvaluacionService.RegistrarHojaEvaluacion(this.hojaEvaluacion).subscribe(data => {

        this.spinner.hide();

        vIdHoja = data.nhojaevalId;

        if (vIdHoja > 0) {

          this.spinner.show();

          this.furService.ActualizarFur(furAntec).subscribe(data => {

            this.spinner.hide();


            if (data.nfurId > 0) {

              this._procesarArchivos(vIdHoja, true, 1);

              // this._postTransacHe(vIdHoja,true);

              // openModalMensaje("Hoja Evaluación",`Se registró correctamente la hoja de evaluación N° ${vIdHoja}, por favor verifique`,
              // this.dialog).afterClosed().subscribe(result=>{

              //   this._GuardarFur(this.idFur,null,null,null);

              //   setTimeout(()=>{

              //     this._Retornar();

              //   },5);

              // });

            } else {
              openModalMensaje('Asignar Información', 'Ocurrió un problema en la actualización del registro', this.dialog).afterClosed().subscribe(result => {

                this._Retornar();

              });

              // flgGuardado = false;

              return;
            }



          }, err => {
            this.spinner.hide();
            console.log(err);
          });

        }

      }, err => {
        this.spinner.hide();
        console.log(err);
      });

    }

  }

  _devolverObservacionASupervisor() {

    // this.furEvaluacion = this.formularioCmp.actualizarFur(this.furEvaluacion);

    this.hojaEvaluacionSegundaEval.listaObservacionDetalle.forEach(observacion => {
        observacion.cobservacionFlgactivo = 'NO';
    });

    setTimeout(() => {

      this.furEvaluacion.nfurIdestado = NumIdEstadoHeEvaluacionSuperv;

      this.spinner.show();

      this.furService.ActualizarFur(this.furEvaluacion).subscribe(data => {

        this.spinner.hide();

        console.log('ACTUALIZAR FUR');
        console.log(data);

        this.hojaEvaluacionService.ActualizarHojaEvaluacion(this.hojaEvaluacionSegundaEval).subscribe(data1 => {
          console.log('ACTUALIZAR HOJA EVAL');
          console.log(data1);
        });

      }, err => {

        this.spinner.hide();
        console.log(err);
      });

    }, 5);

    // console.log(this.furEvaluacion);

    // console.log(this.furEvaluacion);


  }

  _enviarFurASupervisor() {
    let furAntec;

    furAntec = this._setDatosHe(true);

    this.spinner.show();

    this.hojaEvaluacionService.RegistrarHojaEvaluacion(this.hojaEvaluacion).subscribe(data => {

      this.spinner.hide();

      let vIdHoja: number;

      vIdHoja = data.nhojaevalId;

      if (vIdHoja > 0) {

        this.spinner.show();

        this.furService.ActualizarFur(furAntec).subscribe(data => {

          this.spinner.hide();


          if (data.nfurId > 0) {
            //

            this._procesarArchivos(vIdHoja, true, 2);

            // openModalMensaje("Hoja Evaluación",`Se registró correctamente la hoja de evaluación N° ${vIdHoja}, por favor verifique`,
            // this.dialog).afterClosed().subscribe(result=>{

            //   this._GuardarFur(this.furEvaluacion.nfurId,this.strCodSupervDer,GlobalVars.CodPersonal,this.estadoFurEvaluacion);
            //   setTimeout(()=>{
            //   this._Retornar();
            //   },5);
            // });

          } else {
            openModalMensaje('Asignar Información', 'Ocurrió un problema en la actualización del registro', this.dialog).afterClosed().subscribe(result => {

              this._Retornar();

            });

            // flgGuardado = false;

            return;
          }



        }, err => {
          this.spinner.hide();
          console.log(err);
        });

      }

    }, err => {
      this.spinner.hide();
      console.log(err);
    });
  }


    _obtenerDatosFur(idFur: number) {


    }

  _Retornar() {

    this.opRetornaEvaluar.emit();

    // this.router.navigate(['/PanelPrincipal/',GlobalVars.CodUsuario], { relativeTo: this.route });

  }

  _Cancelar() {

    this._Retornar();

  }

  _GuardarFur(vIdFur: number, vUsupervisor: string, vUsuAsignado, estadoFurEval: number) {

    this.formularioCmp.Guardar(vIdFur, vUsupervisor, vUsuAsignado, estadoFurEval);
  }


  cambioResultado(codigoResultado) {



    const vCodRespAcc: string = (this._flgResAnalisisTipo(3) ? this.strCodRespDef : null); // CODIGO PROVISIONAL
    let itemResAnalisis = null;

    if (codigoResultado == 1) {

      this._habilitarCamposFur();

    } else {

      this._deshabilitarCamposFur();

    }

    itemResAnalisis = this.listResAnalisis.filter(x => x.nresanalisisId == codigoResultado)[0];

    this.dscResConclus = itemResAnalisis.cresanalisisDscconc1;
    this.dscResRecomen = itemResAnalisis.cresanalisisDscconc2;

    this.numIdMotivoAcc = null;
    this._setStrCodResponsable(vCodRespAcc); // PROVISIONAL

    this.numIdFurCompl = null;
    this.strCodUNO = null;
    // this.strCodEntidad = null;
    this._setCodEntidad(null);

  }

  _setCodEntidad(dato: string) {

    this.strCodEntidad = dato;

    if (this.busqEntidadC) {this.busqEntidadC.setEntidad(dato, false); }

  }

  _setStrCodResponsable(dato: string) {

    const vSupervisor = this.listSupervisor.find(x => x.cpPerCodigo == dato);

    this.strCodResponsable = dato;

    this.strDscResponsable = (vSupervisor ? vSupervisor.strDscNombreCompleto : null);

  }

    _deshabilitarCamposFur() {

      // console.log("==============_deshabilitarCamposFur");

      this.formularioCmp.denunciaContenedorC.entidadHechoC.entidadComponentReadEnable();
      this.formularioCmp.denunciaContenedorC.hechoIrregularC.hechoIrregularCReadEnable();
      this.formularioCmp.denunciaContenedorC.hechoIrregularC.funcionarioInvolucradoC.funcionarioCReadEnable();
      this.formularioCmp.denunciaContenedorC.hechoIrregularC.empresaInvolucradaC.empresaCReadEnable();
      this.formularioCmp.denunciaContenedorC.pruebaHechoC.pruebaHechoCReadEnable();
      this.formularioCmp.denunciaContenedorC.denunciaContenedorCReadEnable();
      this.formularioCmp.denunciaContenedorC.instanciaC.instanciaCReadEnable();
      if (this.formularioCmp.denunciaContenedorC.pruebaHechoC.cuenta_pruebas) {
        this.formularioCmp.denunciaContenedorC.pruebaHechoC.evidenciaC.evidenciaCReadEnable();
      }

        // Tab denunciante
      setTimeout(() => {
            if (this.formularioCmp.denunciaContenedorC.requireIdentificarse) {
              this.formularioCmp.contenedorDenuncianteC.contenedorDenuncianteReadEnable();
                // this.formularioCmp.contenedorDenuncianteC.contenedorDenuncianteReadEnable();


            // Tab medida de proteccion
              if (this.formularioCmp.contenedorDenuncianteC.denunciante.cdenuncianteFlgmedidaprotec == 'SI') {
              console.log(' :3 : ' + this.formularioCmp.contenedorDenuncianteC.denunciante.cdenuncianteFlgmedidaprotec);

              setTimeout(() => {
                this.formularioCmp.contenedorMpC.medidaProteccionCReadEnable();
                // this.formularioCmp.contenedorMpC.medidaProteccionCReadEnable();

              }, 0);

            }
          }


        }, 0);

    }

    _habilitarCamposFur() {
      this.formularioCmp.denunciaContenedorC.entidadHechoC.entidadComponentReadDisable();
      this.formularioCmp.denunciaContenedorC.hechoIrregularC.hechoIrregularCReadDisable();
      this.formularioCmp.denunciaContenedorC.hechoIrregularC.funcionarioInvolucradoC.funcionarioCReadDisable();
      this.formularioCmp.denunciaContenedorC.hechoIrregularC.empresaInvolucradaC.empresaCReadDisable();
      this.formularioCmp.denunciaContenedorC.pruebaHechoC.pruebaHechoCReadDisable();
      this.formularioCmp.denunciaContenedorC.denunciaContenedorCReadDisable();
      this.formularioCmp.denunciaContenedorC.instanciaC.instanciaCReadDisable();
      // this.formularioCmp.denunciaContenedorC.pruebaHechoC.evidenciaC.evidenciaCReadDisable();
      if (this.formularioCmp.denunciaContenedorC.pruebaHechoC.cuenta_pruebas) {
        this.formularioCmp.denunciaContenedorC.pruebaHechoC.evidenciaC.evidenciaCReadEnable();
      }
      // CUS 05 - 07.
      if (!this.formularioCmp.flgEsFud) {
        // Tab denunciante
        setTimeout(() => {
            if (this.formularioCmp.denunciaContenedorC.requireIdentificarse) {
              this.formularioCmp.contenedorDenuncianteC.contenedorDenuncianteReadDisable();
                // this.formularioCmp.contenedorDenuncianteC.contenedorDenuncianteReadEnable();


            // Tab medida de proteccion
              if (this.formularioCmp.contenedorDenuncianteC.denunciante.cdenuncianteFlgmedidaprotec == 'SI') {

              setTimeout(() => {
                // this.formularioCmp.contenedorMpC.medidaProteccionCReadEnable();
                this.formularioCmp.contenedorMpC.medidaProteccionCReadDisable();
              }, 0);

            }
          }


        }, 0);

      } else {

      }
    }


    _concluir() {
      alert('Concluir.');
    }

    /*CUS06 */


    asignarFlgExistente(evento) {

      this.flgExisteAntecedente = evento.toElement.value;
      console.log('Flg existente: ' + this.flgExisteAntecedente);
    }

    asignarFlgTipoAntecedente(evento) {
      this.flgTipoAntecedente = evento.toElement.value;
      console.log('Flg antecedente: ' + this.flgTipoInformacion);
    }

    asignarFlgInformComplementaria(evento) {
      this.flgInformacionComplementaria = evento.toElement.value;
      console.log('Flg información complementaria: ' + this.flgInformacionComplementaria);
    }

    asignarTipoInformacion(evento) {
      this.flgTipoInformacion = evento.toElement.value;
      console.log('flg tipo información: ' + this.flgTipoInformacion);
    }

    asignarTipoDenuncia(evento) {
      this.flgTipoDenuncia = evento.toElement.value;
    }


    llenarDatosFUD(furEvaluacion: Fur) {

      this.fud.nfudIdfur = furEvaluacion.nfurId;

      this.fud.cfudCodtipo = 'FUD';
      this.fud.strDfudFecregistro = GetDateTime(0, 0);
      this.fud.nfudIdestado = NumIdEstadoFudPendiente ;



    }
    /*CUS 07 */

    _llenarDatosHojaEval(idFurAsignHojaEval: number) {

    }
  _deshabilitarCamposHojaEval() {
    this.flgLecturaFud = true;
    // throw new Error("Method not implemented.");
  }
  _llenarDatosVistaHojaEval(hojaEval: HojaEvaluacion) {
     if (hojaEval.chojaevalFlgexisantec != null) {
       this.flgExisteAntecedente = hojaEval.chojaevalFlgexisantec;
     }
     if (hojaEval.chojaevalFlgtipoantec != null) {
        this.flgTipoAntecedente = hojaEval.chojaevalFlgtipoantec;
     }

     if (hojaEval.chojaevalTipodenun != null) {
        this.flgTipoDenuncia = hojaEval.chojaevalTipodenun;
     }

     if (hojaEval.chojaevalFlginfcompl != null) {
        this.flgInformacionComplementaria = hojaEval.chojaevalFlginfcompl;
     }

     if (hojaEval.chojaevalTipinform != null) {
        this.flgTipoInformacion = hojaEval.chojaevalTipinform;
     }

     this.numIdResAnalisis = hojaEval.nhojaevalIdresanalisis;
     this.dscResConclus = hojaEval.chojaevalDscconclusion1;
     this.dscResRecomen = hojaEval.chojaevalDscconclusion2;

     this.strDscComentarios = hojaEval.chojaevalComentarios;
     this.strCodSupervDer = hojaEval.chojaevalCodsupervder;
     this.numIdMotivo = hojaEval.nhojaevalIdmotderiv;
     this.numIdMotivoAcc = this.hojaEvaluacion.nhojaevalIdmotaccion;
     this.strCodResponsable = this.hojaEvaluacion.chojaevalCodrespaccion;
     this.numIdFurCompl = this.hojaEvaluacion.nhojaevalIdcalfur;
     this.strCodUNO = this.hojaEvaluacion.chojaevalCoduno;
      // this.strCodEntidad = this.hojaEvaluacion.chojaevalCodent;

     this._setCodEntidad(this.hojaEvaluacion.chojaevalCodent);

     if (this.hojaEvaluacionSegundaEval.listaObservacionDetalle.length > 0) {
        this.listaObservaciones = this.hojaEvaluacionSegundaEval.listaObservacionDetalle;
        this._cargarTableMaterial();
      }
     this._validacionesFud();
    // throw new Error("Method not implemented.");
  }

  _agregarComentario() {
      if (this.observacion != null && this.observacion.length > 0) {

        const observacion = new ObservacionDetalle();
        observacion.cobservacionCodtipo = 'HEV';
        observacion.cobservacionDsc = this.observacion;
        observacion.nobservacionIdtipo = this.hojaEvaluacionSegundaEval.nhojaevalId;
        this.listaObservaciones.push(observacion);
        this._cargarTableMaterial();
        this.observacion = '';
      }
  }

  _cargarTableMaterial() {
    setTimeout(() => {

      this.dataSource = new MatTableDataSource(this.listaObservaciones);

      if (this.paginator != null) {this.paginator._intl.itemsPerPageLabel = DscTituloPaginator; } // this.paginator._intl.itemsPerPageLabel = DscTituloPaginator;

      // this.paginator._intl.itemsPerPageLabel = DscTituloPaginator;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

    }, 1);

  }

  _eliminar(observacion) {
    this.listaObservaciones.splice(this.listaObservaciones.indexOf(observacion), 1);
    this._cargarTableMaterial();
  }

  _aprobar() {

    this.llenarDatosFUD(this.furEvaluacion);

    this.furEvaluacion.nfurIdestado = NumIdEstadoAtendido;

    this.spinner.show();

    this.furService.ActualizarFur(this.furEvaluacion).subscribe(data => {

      this.spinner.hide();

      openModalMensaje('Hoja Evaluación', `Se actualizó la hoja de evaluación del fud N° ${this.furEvaluacion.nfurIdbase}`, this.dialog).afterClosed().subscribe(result => {

        // this._Retornar();
      });
    }, err => {
      this.spinner.hide();
      console.log(err);
    });

    this.spinner.show();


  }

  _observar() {
    this.errorValidator = this.mFuncErrorVal.AgregarErrorValidator((this.numIdResAnalisis != null ? false : true), 'Ingrese el resultado del análisis', this.errorValidator, true);
    this.errorValidator = this.mFuncErrorVal.AgregarErrorValidator((this.dscResConclus.length > 0 ? false : true), 'Ingrese la conclusión', this.errorValidator, false);
    this.errorValidator = this.mFuncErrorVal.AgregarErrorValidator((this.dscResRecomen.length > 0 ? false : true), 'Ingrese la recomendación', this.errorValidator, false);
    this.errorValidator = this.mFuncErrorVal.AgregarErrorValidator((this.strCodSupervDer.length > 0 ? false : true), 'Ingrese al supervisor', this.errorValidator, false);
    this.errorValidator = this.mFuncErrorVal.AgregarErrorValidator((this.strDscComentarios.length > 0 ? false : true), 'Ingrese los comentarios', this.errorValidator, false);

    this.errorValidator = this.mFuncErrorVal.AgregarErrorValidator((this.listaObservaciones.length > 0 ? false : true), 'Ingrese por lo menos una observación', this.errorValidator, false);

    this.hojaEvaluacionSegundaEval.listaObservacionDetalle = this.listaObservaciones;
    console.log(this.hojaEvaluacionSegundaEval);
    console.log(this.listaObservaciones);
    this.furEvaluacion.nfurIdestado = NumIdEstadoHeEvaluacionObservado;

     /*  this.hojaEvaluacionService.registrarObservaciones(this.listaObservaciones).subscribe(data=>{
        console.log(data);
      }); */

    if (this.listaObservaciones.length > 0) {

        this.hojaEvaluacionSegundaEval.listaObservacionDetalle = this.listaObservaciones;

        this.spinner.show();

        this.hojaEvaluacionService.ActualizarHojaEvaluacion(this.hojaEvaluacionSegundaEval).subscribe(data => {

          this.spinner.hide();

          if (data != null) {

            this.spinner.show();

            this.furService.ActualizarFur(this.furEvaluacion).subscribe(data => {

              this.spinner.hide();

              openModalMensaje('Hoja Evaluación', `Se observó la hoja de evaluación del fud N° ${this.furEvaluacion.nfurIdbase}`, this.dialog).afterClosed().subscribe(result => {

                // this._Retornar();
              }, err => {
                this.spinner.hide();
                console.log(err);
              });
            });

          }

        }, err => {
          this.spinner.hide();
          console.log(err);
        });
      } else {
       // this.mFuncErrorVal.RevisarErrorValidator(this.errorValidator);
      }


  }

  _descargarPdf() {

    const vPlantillaDocumento: PlantillaDocumento = new PlantillaDocumento();
    const vDscNomFile = 'wordGeneradoCGR.docx';

    // vPlantillaDocumento.datos = this.pdDatos;

    vPlantillaDocumento.datos = [];
    vPlantillaDocumento.datos[0] = new PDDatos();
    vPlantillaDocumento.datos[0].campo = 'campo';
    vPlantillaDocumento.datos[0].nombre = 'nombre';
    vPlantillaDocumento.datos[0].valor = 'valor';


    vPlantillaDocumento.nombreArchivoPlantilla = 'WORDCGR.DOCX';
    vPlantillaDocumento.rutaArchivoGenerado = 'C:/archivos/';

    vPlantillaDocumento.nombreArchivoGenerado = vDscNomFile ;

    this.spinner.show();

    this.externosService.generarDocumento(vPlantillaDocumento).subscribe(
      data => {

        this.spinner.hide();

        saveContent(data.base64, vDscNomFile );

      },
      err => {

        this.spinner.hide();

        console.log(err);

      });

    // this._generarPlantilla();


  }

  _generarPlantilla(numIdFur: number) {

  }


  _validacionesFud() {
    // console.log("Validación FUD");
    // console.log( this.estadoFurEvaluacion);
    // console.log(this.furEvaluacion.nfurIdestado);
     if (this.numIdResAnalisis == NumResultadoAnalisDenuncia && this.furEvaluacion.nfurIdestado != NumIdEstadoHeEvaluacionSuperv) {
      // console.log("Validación FUD d");
      this._habilitarCamposFur();
     } else {
      //  console.log("Validación FUD i ");
      this._deshabilitarCamposFur();

     }
  }

}
